import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ressources } from '@data/ressources';
import { Ressource } from '@models/ressource';

@Component({
  selector: 'app-ressources',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './ressources.component.html',
  styleUrl: './ressources.component.css'
})
export class RessourcesComponent implements OnInit {
  ressources: Ressource[] = ressources;

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Actualités Tech & Recommandations Node.js / Angular — Mesh Box");
    this.metaService.updateTag({ name: 'description', content: "Retrouvez les analyses, guides et recommandations de nos experts sur Node.js, Angular et l'IA. Veille technique et bonnes pratiques pour votre SI." });
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
  }
}